
export class MessageUtils {

  public static getCopyrightMessage() {
    let currentYear = new Date().getFullYear();
    return `Copyright © 2016-${currentYear} NiCE LTD`;
  }

}
